module.exports = __webpack_public_path__ + "img/cta2.4c4a39aa.jpg";